import React from "react"
import ImageCarouselItem from "./ImageCarouselItem"
import styled from "styled-components"

const Container = styled(ImageCarouselItem)`
  margin-left: 0 !important;
  .fluid-container {
    width: 100vw;
    max-height: calc(100vh - 110px);
    height: 100%;
  }
`

const SlideCarouselItem = ({ item, reference, ...props }) => (
  <Container {...item} objectFit="cover" reference={reference} {...props} />
)

export default React.forwardRef((props, ref) => {
  return <SlideCarouselItem {...props} reference={ref} />
})
